import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;

export const getInformeParticipante = async (params = {}) => {
  try {
    const response = await axios.get(`${baseUrl}/api/informeDocumentoActas`, {
      params,
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener informe de actas:", error);
    throw error;
  }
};
